export default __webpack_public_path__ + "static/media/placeholder_dummy2016-fotograf01-mobile-de.855fcd08.png";